import * as React from "react";
import styled from "styled-components";
import SearchIcon from "@mui/icons-material/Search";
import { Paper, InputBase, IconButton } from "@mui/material";

// Styled Input
const StyledInput = styled(InputBase)`
  width: 100%;
  &::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    opacity: 0.4;
  }
`;

export default function Search({ handleSearchDebounce, setPage }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: "15px 18px",
        display: "flex",
        alignItems: "center",
        width: "200px",
        height: "50px",
        borderRadius: "30px",
        justifyContent: "space-between",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      }}
    >
      <StyledInput
        placeholder="Search"
        sx={{
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#000000",
            opacity: 0.4,
            mixBlendMode: "normal",
          },
        }}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
          setPage(1);
          handleSearchDebounce(e.target.value);
        }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon sx={{ color: "#231F20" }} />
      </IconButton>
    </Paper>
  );
}
